import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';

let uid = 0;

/**
 * Small square, bordered icon-only button (white bg, rounded corners,
 * tone-colored hover) - the edit/delete style used in list rows.
 */
const SquareIconButton = ({ icon, onClick, title, id, disabled, tone }) => {
  const buttonId = useRef(id || `square-icon-btn-${(uid += 1)}`);

  return (
    <>
      <button
        type="button"
        id={buttonId.current}
        className={`square-icon-btn${tone !== 'default' ? ` square-icon-btn--${tone}` : ''}`}
        onClick={onClick}
        disabled={disabled}
      >
        {icon}
      </button>
      {title && (
        <UncontrolledTooltip placement="bottom" target={buttonId.current}>
          {title}
        </UncontrolledTooltip>
      )}
    </>
  );
};

SquareIconButton.propTypes = {
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  tone: PropTypes.oneOf(['default', 'danger']),
};

SquareIconButton.defaultProps = {
  title: '',
  id: undefined,
  disabled: false,
  tone: 'default',
};

export default SquareIconButton;
